import { useContext } from 'react'
import { ToastArgs, ToastContext } from 'components/Toast'

export default function useToast() {
  const context = useContext(ToastContext)
  return (args: ToastArgs) => context.addToast(args)
}
